// Broadcast a single cross tab signal when the cookie changes.
// Throttled a bit to avoid floods during rapid typing.
let _lastTimer = null;
let _pendingPayload = null;

export function updateLocalStorageAlert() {
    const payload = {
        source: window.__MY_KIT_TAB_ID__ || "unknown",
        ts: Date.now()
    };
    _pendingPayload = payload;

    if (_lastTimer) clearTimeout(_lastTimer);
    _lastTimer = setTimeout(() => {
        try {
            localStorage.setItem("myKitUpdated", JSON.stringify(_pendingPayload));
        } catch {}
        window.dispatchEvent(new CustomEvent("myKit:updated", { detail: _pendingPayload }));
        _lastTimer = null;
        _pendingPayload = null;
    }, 150);
}
